import styled from 'styled-components';
import { Box, RadioButton } from 'vqp-common'
import { Button } from '../../../components/common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 13px;
`
export const Title = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: ${props => props.theme.colors.primary}
    border-bottom: 1px solid ${props => props.theme.colors.lineGrey};
`
export const SubTitle = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 15px;
    font-weight: 700;
    width: 100%;
    color: ${props => props.theme.colors.primary}
    margin-bottom: .6rem;

    > div{
        cursor: pointer;
        margin-right: 2rem;
        color: ${props => props.theme.colors.textBold};

        &.selected{
            color: ${props => props.theme.colors.primary}
            border-bottom: 2px solid;
            padding-bottom: 5px;
        }
    }
`
export const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
`
export const SubCard = styled.div`
    margin-bottom: 2rem;
`
export const Col1 = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin: 35px 20px;
`
export const Divider = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.lineGrey};
`
export const H4 = styled.h4`
   font-size: 13px;
   font-weigth: bold;
   color: ${props => props.theme.colors.primary};
   margin: 0 1rem 0 0;
`

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;

    &.check{
      margin-bottom: 1rem;
    }
`

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    width: 31%;
    margin-right: 20px;
    margin-bottom: 15px;

    &.restrictions{
      width: 100%;
    }
`

export const CustomLabel = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.textPrimary};
  margin: 0 0 4px 0;

  &.restrictions{
    font-weight: 500;
  }

  &.bottom-line{
    border-bottom: 1px solid ${props => props.theme.colors.lineGrey};
    margin: 0 0 20px 0;
  }
`
export const CheckboxWrapper = styled.div`
    font-size: 12px;
    padding-right: 2rem;
`
export const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 11px !important;
    color: ${props => props.theme.colors.textBold};
    margin: 10px;

    ${RadioButton} {
        & label {
            margin-bottom: 0;
        }
        & span {
            top: initial;
        }
    }
`
export const Div = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${props => props.theme.colors.lineGrey};
    padding: .7rem;
    border-radius: 7px;
    margin: 10px 0;
`
export const DivButton = styled.div`
    display: flex;
    flex-direction: row;
    margin: 10px 0 10px 8px;
    padding: 8px;
    border-radius: 10px;
    align-items: center;
`
export const DivButtonSave = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0 10px 8px;
    padding: 8px;
    border-radius: 10px;
    align-items: center;
`
export const SaveButton = styled(Button)`
`
export const FieldWrapper = styled.div`
`
export const NewHoursButton = styled(Button)`
    margin-left: 10px;
`
export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
    font-size: 13px;
`
export const Thead = styled.thead`
`
export const Tbody = styled.tbody`
    >tr:nth-child(even) {
      background-color: #dddddd;
    }
`
export const Td = styled.td`
    border: 1px solid #dddddd;
    text-align: center;
    padding: 8px;
`
export const Tr = styled.tr`
`
export const Th = styled.th`
    border: 1px solid #dddddd;
    text-align: center;
    padding: 8px;
`
export const CustomAlert = styled.div`
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.secondWarning};
    border-radius: 5px;
    padding: 0.3rem;
    text-align: center;
`
export const Strong = styled.span`
    font-weight: bold;
    font-size: 16px
    color: ${props => props.theme.colors.primary};
`
export const CustomIcon = styled.div`
    cursor: pointer;
    margin: 6px;
`
export const Action = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`
export const NewProductButton = styled(Button)`
    margin-left: auto;

    &.create{
      margin-top: -55px;
    }
`
export const DeleteButton = styled(Button)`
    margin: 20px 0 6px 0;
`
export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export const Span = styled.div`
    color: ${props => props.theme.colors.textBold};
    font-size: 14px;
`
